import * as axios from 'axios';
import { from } from 'rxjs';

axios.defaults.withCredentials = false

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const originalRequest = error.config;
  if (error.response && error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
  }
  return Promise.reject(error);
});

export class HttpRequest {

  get(url) {
    var request = axios.get(url).then(res => res).catch(error => {
      return this.handleError(error);
    });
    return from(request);
  }

  post(url, data) {
    var request = axios.post(url, data).then(res => res).catch(error => {
      return this.handleError(error);
    });
    return from(request);
  }

  put(url, data) {
    var request = axios.put(url, data).then(res => res).catch(error => {
      return this.handleError(error);
    });
    return from(request);
  }

  delete(url, data) {
    var request = axios.delete(url, data).then(res => res).catch(error => {
      return this.handleError(error);
    });
    return from(request);
  }

  handleError(error) {
    if (error.message === 'Network Error') { // Handle Network Error
      return {
        status: 'Network Error',
        data: {
          message: " NOTIFICATIONS.CONNECTIVITY_ERROR"
        }
      }
    } else { // Server Error

      if (error.response && error.response.status === 403) {
        return error.response;
      } else {
        return error.response;
      }
    }
  }
}